import React, { useEffect, useState } from 'react';

const radioSelectorStyle = {
  container: {
    height: '35px',
    width: '200px',
    marginLeft: '25px',
    display: 'flex',
    boxSizing: 'border-box',
  },
  selected: {
    backgroundColor: '#fff',
    color: 'black',
    padding: 4
  },
  notSelected: {
    cursor: 'pointer',
    padding: 4
  },
};

const SelectorTchatChannel = (props) => {
  const {leftValue, rightValue, defaultValue} = props;
  const [value, setValue] = useState(defaultValue ? defaultValue : leftValue)

  // Gestion des appels API lors du changement de valeur du radio
  useEffect(() => {
    props.onChange(value);
  }, [value]);

  // Render du composant
  return (
    <div style={radioSelectorStyle.container}>
      <div
        className="radio-selector left-radio-selector"
        style={value === leftValue ? radioSelectorStyle.selected : radioSelectorStyle.notSelected}
        onClick={() => setValue(leftValue)}
      >
        {leftValue}
      </div>
      <div
        className="radio-selector right-radio-selector"
        style={value === rightValue ? radioSelectorStyle.selected : radioSelectorStyle.notSelected}
        onClick={() => setValue(rightValue)}
      >
        {rightValue}
      </div>
    </div>
  );
};

export default SelectorTchatChannel;
